import { SidebarProvider, Toaster } from '@9b3kuq5phwuk4txw/kiban-react-ui/primitives'
import { createRootRoute, Outlet, useRouterState } from '@tanstack/react-router'
import { AppHeaderContainer } from '@/components/AppHeaderContainer'

function RootComponent() {
  const router = useRouterState()
  const isLoginPage = router.location.pathname === '/login'

  return (
    <SidebarProvider id='root' className='flex flex-col h-screen overflow-hidden'>
      {!isLoginPage && <AppHeaderContainer />}
      <main className={isLoginPage ? '' : 'flex-1 min-h-0 min-w-0'}>
        <Outlet />
      </main>
      <Toaster position='top-right' />
    </SidebarProvider>
  )
}

export const Route = createRootRoute({
  component: RootComponent,
})
